import { render, staticRenderFns } from "./AddFromStock.vue?vue&type=template&id=19f161fe&scoped=true"
import script from "./AddFromStock.vue?vue&type=script&lang=js"
export * from "./AddFromStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f161fe",
  null
  
)

export default component.exports